import publicationService from '../../services/publicationService'

const getDefaultState = () => {
  return {
    publications: []
  }
}

const state = getDefaultState()

// const state = {
//     candidates: []
// }

const getters = {
  publications: state => {
        return state.publications
    }
}

const actions = {
    getPublications ({ commit }) {
      publicationService.fetchPublications()
        .then(publications => {
            commit('setPublications', publications)
        })
    }
}

const mutations = {
    setPublications (state, publications) {
      state.publications = publications
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }